const getDefaultState = () => {
  return {
    all: [],
    loading: false,
  }
}

export const api = {
  getFeedbackRequests: params => {
    return Vue.$http.get('client/feedback_requests', { params: { ...params } })
  },

  getFeedbackRequest: id => Vue.$http.get(`client/feedback_requests/${id}`),

  postFeedbackRequests: feedbackRequests => {
    return Vue.$http.post('client/feedback_requests', {
      opportunityApplications: feedbackRequests.opportunityApplications,
      responders: feedbackRequests.responders,
    })
  },

  updateFeedbackRequest: feedbackRequest => {
    return Vue.$http.patch(`client/feedback_requests/${feedbackRequest.id}`, { ...feedbackRequest })
  },
}

const state = getDefaultState()

const getters = {
  find: state => id => state.all.find(fr => fr.id === id),
  forApplication: state => id => state.all.filter(fr => fr.opportunityApplication.id === id),
}

const mutations = {
  setAll(state, feedbackRequests) {
    state.all = JSON.parse(JSON.stringify(feedbackRequests))
  },

  set(state, feedbackRequest) {
    const find = state.all.find(fr => fr.id === feedbackRequest.id)
    if (find) state.all.splice(state.all.indexOf(find), 1, feedbackRequest)
    if (!find) state.all.push(feedbackRequest)
  },

  resetState(state) {
    Object.assign(state, getDefaultState())
  },

  setLoading(state, loading) {
    state.loading = !!loading
  },
}

const actions = {
  fetchAll({ commit }, params = {}) {
    commit('setLoading', true)
    return api.getFeedbackRequests(params).then(
      ({ data }) => {
        commit('setLoading', false)
        commit('setAll', data)
        return data
      },
      errors => {
        commit('setLoading', false)
        throw errors
      }
    )
  },

  fetch({ commit }, id) {
    return api.getFeedbackRequest(id).then(
      ({ data }) => {
        commit('set', data)
        return data
      },
      errors => {
        throw errors
      }
    )
  },

  create({ commit, state }, feedbackRequests) {
    commit('setLoading', true)
    return api.postFeedbackRequests(feedbackRequests).then(
      ({ data }) => {
        commit('setLoading', false)
        commit('setAll', [...data, ...state.all])
        return data
      },
      errors => {
        commit('setLoading', false)
        throw errors
      }
    )
  },

  update({ commit, state }, feedbackRequest) {
    commit('setLoading', true)
    return api.updateFeedbackRequest(feedbackRequest).then(
      ({ data }) => {
        commit('setLoading', false)
        commit('set', data)
        return data
      },
      errors => {
        commit('setLoading', false)
        throw errors
      }
    )
  },

  resetState({ commit }) {
    commit('resetState')
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
